export const isEmployeeOption = (user) =>
  user?.workerClassification?.classificationType === 'employee';

export const isEmployeeOptionShift = (job) => job?.workerClassification === 'employee';
